import { useEffect, useRef } from 'react';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import icon1 from '../assets/icons/1.png';
import icon2 from '../assets/icons/2.png';
import icon3 from '../assets/icons/3.png';
import icon4 from '../assets/icons/4.png';
import icon5 from '../assets/icons/5.png';
import './TrustBar.css';

gsap.registerPlugin(ScrollTrigger);

const trustItems = [
  { icon: icon1, text: 'NASC QUALITY CERTIFIED' },
  { icon: icon2, text: 'VET APPROVED FORMULATIONS' },
  { icon: icon3, text: '3RD-PARTY LAB TESTED' },
  { icon: icon4, text: 'NO CORN, WHEAT OR SOY' },
  { icon: icon5, text: 'CRAFTED IN USA' },
];

const loopItems = [...trustItems, ...trustItems, ...trustItems, ...trustItems];

export default function TrustBar() {
  const trustBarRef = useRef(null);
  const listRef = useRef(null);

  useEffect(() => {
    const reducedMotion = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
    if (reducedMotion) return undefined;

    const ctx = gsap.context(() => {
      const list = listRef.current;

      // Proxy object: quickTo eases THIS raw, unbounded value.
      // We never wrap the value quickTo is targeting, so it never
      // has to jump/animate across a big distance.
      const proxy = { x: 0 };
      const quickX = gsap.quickTo(proxy, 'x', { duration: 0.5, ease: 'power3.out' });

      let halfWidth = list.scrollWidth / 2;

      // Recalc on resize/font-load etc, since scrollWidth can change
      const recalc = () => { halfWidth = list.scrollWidth / 2; };
      window.addEventListener('resize', recalc);
      const resizeObserver = new ResizeObserver(recalc);
      resizeObserver.observe(list);

      ScrollTrigger.create({
        trigger: '.trust-bar',
        start: 'top bottom',
        end: 'bottom top',
        onUpdate: (self) => {
          const delta = self.getVelocity() / -30; // tune intensity here
          quickX(proxy.x + delta);
        },
      });

      // Render loop: wrap + apply INSTANTLY (no easing on the wrap itself)
      const ticker = () => {
        const wrapped = gsap.utils.wrap(-halfWidth, 0, proxy.x);
        gsap.set(list, { x: wrapped });
      };
      gsap.ticker.add(ticker);

      return () => {
        window.removeEventListener('resize', recalc);
        resizeObserver.disconnect();
        gsap.ticker.remove(ticker);
      };
    }, trustBarRef);

    return () => ctx.revert();
  }, []);

  return (
    <section className="trust-bar" ref={trustBarRef} aria-label="Trillium Paws quality assurances">
      <div className="trust-bar__viewport">
        <ul className="trust-bar__list" ref={listRef}>
          {loopItems.map(({ icon, text }, i) => (
            <li className="trust-bar__item" key={`${text}-${i}`} aria-hidden={i >= trustItems.length ? true : undefined}>
              <img className="trust-bar__icon" src={icon} alt="" aria-hidden="true" />
              <span>{text}</span>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
